import {
    request
} from '../lib/http_request'
import {
    apis
} from '../lib/apis'

// 获取批次列表
const showAllExchangeSequence = obj => new Promise((resolve, reject) => {
    const {
        token,
        querySequenceForm
    } = obj;
    request({
        url: apis.exchange_show_all_sequences + '?token=' + token,
        data:querySequenceForm
    }).then(res => {
        resolve(res);
    })
})
// 获取服务器列表
const getAllChannel = obj => new Promise((resolve, reject) => {
    const {
        token
    } = obj;
    request({
        url: apis.config_setting_channel_list + '?token=' + token,
    }).then(res => {
        resolve(res);
    })
})
// 获取礼包列表
const showGifts = obj => new Promise((resolve, reject) => {
    const {
        token,
        queryGiftForm
    } = obj;
    request({
        url: apis.exchange_show_gifts + '?token=' + token,
        data:queryGiftForm
    }).then(res => {
        resolve(res);
    })
});
// 创建礼包
const createGift = obj => new Promise((resolve, reject) => {
    const {
        token,
        createGiftForm
    } = obj;
    request({
        url: apis.exchange_create_gift + '?token=' + token,
        data:createGiftForm
    }).then(res => {
        resolve(res);
    })
});
// 删除礼包
const deleteGift = obj => new Promise((resolve, reject) => {
    const {
        token,
        id
    } = obj;
    request({
        url: apis.exchange_delete_gift + '?token=' + token+'&id='+id,
    }).then(res => {
        resolve(res);
    })
});
const findCode = obj => new Promise((resolve, reject) => {
    const {
        codeStr,
        token
    } = obj;
    request({
        url: apis.exchange_find + '?token=' + token+ '&codeStr=' + codeStr,
    }).then(res => {
        resolve(res);
    })
});

const queryCode = obj => new Promise((resolve, reject) => {
    const {
        token,
        queryCodeForm
    } = obj;
    request({
        url: apis.exchange_query + '?token=' + token,
        data:queryCodeForm
    }).then(res => {
        resolve(res);
    })
});

const sumCode = obj => new Promise((resolve, reject) => {
    const {
        sumForm,
        token

    } = obj;
    request({
        url: apis.exchange_sum + '?token=' + token,
        data:sumForm
    }).then(res => {
        resolve(res);
    })
});
const createSequence = obj => new Promise((resolve, reject) => {
    const {
        createForm,
        token
    } = obj;
    request({
        url: apis.exchange_create_sequence + '?token=' + token,
        data:createForm
    }).then(res => {
        resolve(res);
    })
});

const updateSequence = obj => new Promise((resolve, reject) => {
    const {
        updateSequenceForm,
        token
    } = obj;
    request({
        url: apis.exchange_update_sequence + '?token=' + token,
        data:updateSequenceForm
    }).then(res => {
        resolve(res);
    })
});

const insertCodeBySequence = obj => new Promise((resolve, reject) => {
    const {
        sequenceId,
        token
    } = obj;
    request({
        url: apis.exchange_insert_code_sequence + '?token=' + token + '&sequenceId='+sequenceId
    }).then(res => {
        resolve(res);
    })
});

const createCode = obj => new Promise((resolve, reject) => {
    const {
        createForm,
        token
    } = obj;
    request({
        url: apis.exchange_create_code + '?token=' + token,
        data:createForm
    }).then(res => {
        resolve(res);
    })
});

const supplyCode = obj => new Promise((resolve, reject) => {
    const {
        id,
        token

    } = obj;
    request({
        url: apis.exchange_supply_code + '?token=' + token+ '&id=' + id,
    }).then(res => {
        resolve(res);
    })
});

const exportExcel = obj => new Promise((resolve, reject) => {
    const {
        sequenceId,
        token
    } = obj;
    window.location.href = apis.exchange_export_excel + '?token=' + token+'&sequenceId='+sequenceId
});


const banSequence = obj => new Promise((resolve, reject) => {
    const {
        listForm,
        token
    } = obj;
    request({
        url: apis.exchange_ban_sequence + '?token=' + token,
        data:listForm,
    }).then(res => {
        resolve(res);
    })
});

const enableSequence = obj => new Promise((resolve, reject) => {
    const {
        listForm,
        token
    } = obj;
    request({
        url: apis.exchange_enable_sequence + '?token=' + token,
        data:listForm,
    }).then(res => {
        resolve(res);
    })
});

const deleteSequence = obj => new Promise((resolve, reject) => {
    const {
        id,
        token
    } = obj;
    request({
        url: apis.exchange_delete_sequence + '?token=' + token+'&sequenceId='+id,
    }).then(res => {
        resolve(res);
    })
});


const banCode = obj => new Promise((resolve, reject) => {
    const {
        id,
        token
    } = obj;
    request({
        url: apis.exchange_ban_code + '?token=' + token+ '&id=' + id,
    }).then(res => {
        resolve(res);
    })
});

const getExchangeHistory = obj => new Promise((resolve, reject) => {
    const {
        queryExchangeHistoryForm,
        token
    } = obj;
    request({
        url: apis.exchange_code_history + '?token=' + token,
        data:queryExchangeHistoryForm
    }).then(res => {
        resolve(res);
    })
});

export default {
    showAllExchangeSequence,
    getAllChannel,
    showGifts,
    createGift,
    deleteGift,
    findCode,
    queryCode,
    sumCode,
    createSequence,
    updateSequence,
    insertCodeBySequence,
    createCode,
    supplyCode,
    exportExcel,
    banSequence,
    enableSequence,
    deleteSequence,
    banCode,
    getExchangeHistory
}



// WEBPACK FOOTER //
// ./src/service/exchange_api.js